import React, { useCallback, useEffect, useState } from 'react';
import api from '~/services/api';

import { useForm } from 'react-hook-form';
import { InputSelect } from '../NovosInputs';
import { Container } from './styles';

interface Options {
  label: string | undefined;
  value: number | string | undefined;
}

interface IPdv {
  num_pdv: number;
  cod_loja: number;
}

interface PdvProps {
  value: Options | undefined | null;
  loja: number[] | undefined | number;
  onChange(val: any, data: boolean): void;
  label?: string | undefined;
  isDisabled?: boolean;
  setInvalid?: boolean;
  placeholder?: string;
}

/**
 * @param label Nome que será exibido na parte superior do componente
 * @function onChange Função que atualiza o valor do input
 * @returns Componente para validação de inputs
 */
const BuscaPdvLoja: React.FC<PdvProps> = (props) => {
  const {
    loja,
    onChange,
    value,
    label = 'Caixa',
    isDisabled,
    setInvalid,
    placeholder = 'Selecione...',
  } = props;

  const [pdvs, setPdvs] = useState<Options[]>([]);
  const [pdvsAtivos, setPdvsAtivos] = useState<Options[]>([]);

  const { control, register, setValue } = useForm();

  useEffect(() => {
    (async () => {
      const { data } = await api.post(`/busca-pdvs`, { lojas: loja });
      if (data.success && data.data) {
        const options = data.data.map((pdv: IPdv) => ({
          label: pdv.num_pdv,
          value: pdv.num_pdv,
        }));

        const optAtivos = data.data.flatMap((pdv: any) => {
          if (pdv.flg_inativo !== true) {
            return [
              {
                label: `${pdv.num_pdv}`,
                value: pdv.num_pdv,
              },
            ];
          }
          return [];
        });

        setPdvs(options);
        setPdvsAtivos(optAtivos);
      }
    })();
  }, [loja]);

  const handleChangePdv = useCallback(
    (val: { label: string; value: number }, isInvalid: boolean) => {
      setValue('num_pdv', val);
      onChange(val, isInvalid);
    },
    [onChange, setValue],
  );

  useEffect(() => {
    if (value) setValue('num_pdv', value);
    else setValue('num_pdv', { label: undefined, value: undefined });
  }, [setValue, value]);

  return (
    <Container>
      <div className="col-sm-12">
        <InputSelect
          placeholder={placeholder}
          options={pdvsAtivos as any[]}
          label={label}
          isDisabled={isDisabled}
          control={control}
          register={register}
          name="num_pdv"
          isError={!!setInvalid}
          changeSelected={(newValue: any) => {
            handleChangePdv(newValue, false);
          }}
        />
      </div>
    </Container>
  );
};

export default BuscaPdvLoja;
